import React from 'react';
import PropTypes from 'prop-types';
import {ProductShowContext} from "../../context/ProductShowContext";
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {FormattedMessage} from "react-intl";
import FormattedNumberWithCurrency
    from "../../../../../../components/formattedNumberWithCurrencies/formattedNumberWithCurrency";


VariationPriceBackLog.propTypes = {
    variation: PropTypes.arrayOf(
        PropTypes.shape({
            retailerOptionValues: PropTypes.array,
            pictures: PropTypes.array,
            stock: PropTypes.number,
            sku: PropTypes.string
        })
    )
};

function VariationPriceBackLog({variation}) {
    const organization = React.useContext(ProductShowContext);
    if (!variation) {
        return null;
    }

    if (variation.priceBackLogs.length === 0) {
        return (
            <div style={{ textAlign: "center", margin: "16px" }}>
                <FormattedMessage id={'variation.priceBackLog.empty'}/>
            </div>
        );
    }

    const backLogs = variation.priceBackLogs.sort((a, b) => {
        if (b.enable !== a.enable) {
            return b.enable - a.enable;
        }

        return new Date(a.fromDate) - new Date(b.fromDate);
    });

    return (
        <TableContainer>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell><FormattedMessage id={'variation.priceBackLog.table.type'}/></TableCell>
                        <TableCell><FormattedMessage id={'variation.priceBackLog.table.price'}/></TableCell>
                        <TableCell><FormattedMessage id={'variation.priceBackLog.table.fromDate'}/></TableCell>
                        <TableCell><FormattedMessage id={'variation.priceBackLog.table.toDate'}/></TableCell>
                        <TableCell><FormattedMessage id={'variation.priceBackLog.table.pushedAt'}/></TableCell>
                        <TableCell><FormattedMessage id={'variation.priceBackLog.table.name'}/></TableCell>
                        <TableCell><FormattedMessage id={'variation.priceBackLog.table.enable'}/></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {backLogs.map((row) => (
                        <TableRow
                            key={row.id}
                            sx={{
                                '&:last-child td, &:last-child th': { border: 0 },
                                backgroundColor: row.enable === false ? '#f8f9fa' : 'inherit',
                                '& td': { color: row.enable === false ? '#999999' : 'inherit' },
                            }}
                        >
                            <TableCell scope="row">
                                <FormattedMessage id={`variation.priceBackLog.table.type.${row.type}`}/>
                            </TableCell>
                            <TableCell scope="row">
                                <FormattedNumberWithCurrency value={row.price} currency={organization?.currency} />
                            </TableCell>
                            <TableCell>{new Intl.DateTimeFormat(organization?.defaultLocale, { timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(new Date(row.fromDate))}</TableCell>
                            <TableCell>
                                {row.toDate ?
                                    <>{new Intl.DateTimeFormat(organization?.defaultLocale, { timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(new Date(row.toDate))}</>
                                :
                                    <FormattedMessage id={`variation.priceBackLog.table.toDate.noDate`}/>
                                }
                            </TableCell>
                            <TableCell>
                                {row.pushedAt ?
                                    <>{new Intl.DateTimeFormat(organization?.defaultLocale, { timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(new Date(row.pushedAt))}</>
                                :
                                    <>N/A</>
                                }
                                </TableCell>
                            <TableCell>{row.name ?? 'N/A'}</TableCell>
                            <TableCell>
                                {row.enable === false ?
                                    <FormattedMessage id={`variation.priceBackLog.table.enable.false`}/>
                                : new Date(row.fromDate) > new Date() ? (
                                    <FormattedMessage id={`variation.priceBackLog.table.enable.toCome`}/>
                                ) : row.toDate === null || new Date(row.toDate) > new Date() ? (
                                    <FormattedMessage id={`variation.priceBackLog.table.enable.true`}/>
                                ) : (
                                    <FormattedMessage id={`variation.priceBackLog.table.enable.false`}/>
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default VariationPriceBackLog;
